(function () {
    'use strict';
    angular
        .module('UNIFYPortal')
        .constant('FilterIgnoreConstant', {
            'url': ['caApply','allOrg','moreNotice','apply','accessdenied','error','home', 'login','login-welcome','cardManagement','groupManagement','configManagement']
        });
})();
